import styled from 'styled-components'

export const Wrapper = styled.div`
   
    
    display:grid;
    padding: 0 20px;
    align-items:center;    
    max-width:100%;
    justify-content:space-around;
    margin:auto;
    
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15), 0 12px 20px rgba(0, 0, 0, 0.2);
    
    
    @media screen and (max-width: 400px) {
          grid-auto-flow: row;
        }

    h1 {
        color: var(--medGrey);

        @media screen and (max-width: 768px) {
            font-size: var(--fontBig);
        }

    }
`;

export const Content = styled.div`
    display:grid;
   background-color: var(--lightGrey);
    grid-gap: 0.4rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15), 0 12px 20px rgba(0, 0, 0, 0.2);
`;
